import TYPES from '../../types';

// Domain
import { RelationshipEntity } from '../../domain/entities/relationship-entity';
import { RelationshipRepository } from '../../domain/repository/relationship-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchRelationshipsQuery extends Query<Array<RelationshipEntity>> {
  @Inject(TYPES.CATALOG_ALLIANZ_RELATIONSHIP_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_ALLIANZ_RELATIONSHIP_REPOSITORY)
  private readonly repository!: RelationshipRepository;

  internalExecute() {
    if (!this.state_manager.state.loaded) {
      this.repository.execute()
        .then((items) => {
          this.state_manager.patch({ items, loaded: true });
        });
    }

    return this.state_manager.state.items;
  }
}
